import React from 'react';
export function HeroSection() {
  return <div className="bg-navy py-16 px-4" data-id="element-234">
      <div className="max-w-4xl mx-auto text-center" data-id="element-235">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-4" data-id="element-236">
          About Peak Machine Sales
        </h1>
        <p className="text-lg md:text-xl text-white/80" data-id="element-237">
          Michigan's Most Trusted CNC Machine Tool Dealer
        </p>
      </div>
    </div>;
}